import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getCurrentUser } from '../services/authService';

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const user = getCurrentUser();

  // ✅ Simple check - verify user data exists
  // Server will validate the HTTP-only cookie automatically
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;